<template>
    <div
        class="cashback padded-page"
        :class="{
            none: status === 'none',
        }"
        ref="screenWrapper"
    >
        <template v-if="status === 'none'">
            <p class="text-lg mb-3">You didn't earn any cashbacks 😔.</p>
            <p class="mb-2">Every little bit counts!</p>
            <p>Create a savings plan to earn cashback on all your bill payments.</p>
        </template>
        <div v-else-if="status === 'high'" class="mb-5 text-white font-satoshi_r">
            <p class="text-lg">You earned</p>
            <p class="text-4xl font-satoshi_b font-bold my-1"><CountUpNumber :endVal="reviewData?.total_cashback ?? 0" currency="₦" /></p>
            <p class="mb-4">as cashback on your bills from Sycamore in 2025.</p>
            <p>Keep saving to stay earning</p>
        </div>
        <div v-else class="mb-5 text-white font-satoshi_r">
            <p class="text-lg">You earned less than</p>
            <p class="text-4xl font-satoshi_b font-bold my-1"><CountUpNumber :endVal="reviewData?.total_cashback ?? 0" currency="₦" /></p>
            <p class="mb-4">as cashback on your bills from Sycamore in 2025.</p>
            <p>Every little bit counts! Create a savings plan to earn cashback on all your bill payments.</p>
        </div>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        status() {
            if (this.reviewData?.total_cashback <= 0) return "none";
            if (this.reviewData?.total_cashback > 0 && this.reviewData?.total_cashback < 5000) return "low";
            return "high";
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.goForward();
        });
    },
};
</script>

<style scoped>
.cashback {
    color: white;
    min-height: 100vh;

    background-color: #ec9000;
    background-image: url("../../assets/images/year-in-review/cashback.svg");
    background-repeat: no-repeat;
    background-position: 100% 70%;
}

.cashback.none {
    background-image: url("../../assets/images/year-in-review/cashback-none.svg");
}

@media (max-height: 750px) {
    .cashback {
        background-size: auto 50%;
    }
}
</style>
